import { includes, isNumber } from 'lodash-es'

import { Depot, Point } from '@freighthub/freighthub-quotation-sdk'
import { TransportScheme } from '@freighthub/freighthub-transportplanning-sdk'

import { getFullAddress } from '@/features/shipments'

import { TransportPlanExtractor } from './transportPlanExtractor'
import { Address } from '../domain/locationAddress'
import { Port } from '../domain/port'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export const isAddress = (address: any): address is Address => {
  // check for 'types' field, in case old format provided
  return typeof address === 'object' && includes(address?.types, 'address')
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export const isDepot = (address: any): address is Address => {
  // check for 'types' field, in case old format provided
  return typeof address === 'object' && includes(address?.types, 'depot')
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export const isPort = (port: any): port is Port => {
  return isSeaPort(port) || isAirPort(port) || isRailPort(port)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export const isSeaPort = (port: any): port is Port => {
  // check for 'types' field, in case old format provided
  return typeof port === 'object' && port.types && port.types.indexOf('sea') > -1
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export const isAirPort = (port: any): port is Port => {
  // check for 'types' field, in case old format provided
  return typeof port === 'object' && port.types && port.types.indexOf('air') > -1
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
const isRailPort = (port: any): port is Port => {
  // check for 'types' field, in case old format provided
  return typeof port === 'object' && port.types && port.types.indexOf('rail') > -1
}

export const pickup = (transportPlan: TransportScheme): Point => {
  const tpExtractor = new TransportPlanExtractor()
  const originAddresses = tpExtractor.getOriginAddresses(transportPlan)

  return originAddresses[0] || ({} as Point)
}

export const delivery = (transportPlan: TransportScheme): Point => {
  const tpExtractor = new TransportPlanExtractor()
  const deliveryAddresses = tpExtractor.getDestinationAddresses(transportPlan)

  return deliveryAddresses[0] || ({} as Point)
}

export const isPositive = (value: number): boolean => {
  return Boolean(value && isNumber(value) && Number(value) > 0)
}

export function pointToString(point: Point): string {
  if (point == null) return ''
  if (isAddress(point)) {
    return getFullAddress(point)
  } else if (isDepot(point)) {
    return (point as Depot).name
  } else {
    return (point as Port).name
  }
}

// --------------- UTILITY functions for Locations ----------------
/**
 * Formats an address as string
 * @param  {Object} address
 * @param  {boolean} short   returns short address when true (only postalcode and country)
 * @param  {Array<string>} omit    Array of properties to omit
 * @return {string}
 */
export function formatAddress(address: Address, short?: boolean, omit?: string[]) {
  function omitValue(key: string) {
    return omit && omit.indexOf(key) >= 0
  }

  let str = ''
  if (address.description && !omit) {
    return address.description
  }

  if (address.companyName) {
    str += `${address.companyName}, `
  }

  if (address.street && !short && !omitValue('street')) {
    str += address.street
    str += address.streetNumber ? ` ${address.streetNumber}` : ''
    str += ', '
  }
  if (address.postalCode && !omitValue('postalCode')) {
    str += `${address.postalCode} `
  }
  if (address.district && !omitValue('district')) {
    str += `${address.district}, `
  }
  if (address.city && !omitValue('city')) {
    str += address.city
  }
  if (!address.city && address.state && !omitValue('state')) {
    str += address.state
  }
  if (!omitValue('country')) {
    str += `, ${address.country}`
  }
  return str
}
